const VALID_TRANSLATOR_LANGS = ['none', 'zh', 'en']
const CHINESE_RE = /[\u4e00-\u9fff]/
const ENGLISH_RE = /[A-Za-z]/

function normalizeTranslatorLang(lang) {
    return VALID_TRANSLATOR_LANGS.indexOf(lang) > -1 ? lang : 'none'
}

function shouldTranslateText(text, targetLang) {
    const content = String(text || '').trim()
    if (!content) return false
    if (targetLang === 'en') return CHINESE_RE.test(content)
    if (targetLang === 'zh') return ENGLISH_RE.test(content)
    return false
}

module.exports = {
    VALID_TRANSLATOR_LANGS,
    CHINESE_RE,
    ENGLISH_RE,
    normalizeTranslatorLang,
    shouldTranslateText
}
